import { NbJSThemeOptions, DEFAULT_THEME as baseTheme } from "@nebular/theme";

const baseThemeVariables = baseTheme.variables;

export const DEFAULT_THEME = {
  name: "default",
  base: "default",
  variables: {},
} as NbJSThemeOptions;
